export class NewQuotation {
    idQuotationItem:number;
    quotationItem:any;
    quotationItemHSNSAC:any;
    quotationItemGST:any;
    quotationItemQuantity:any;
    quotationItemRate:any;
	quotationAmmount:any;
    operationState="i";
    IsRemove :false;

}